import { panel } from 'vue-strap'

export default {
    extends: panel,
    render (h) {
        const source = this.$slots.header || [h('span', [this.header || ''])]
        // Header slots in this app contain text, strong/u, and h4 elements.
        // Keep their formatting without nesting a heading inside the button.
        const flattenHeadings = nodes => nodes.reduce((result, node) => {
            if (node.tag && /^h[1-6]$/.test(node.tag)) return result.concat(flattenHeadings(node.children || []))
            result.push(node.tag ? h(node.tag, node.data, flattenHeadings(node.children || [])) : node)
            return result
        }, [])
        const label = flattenHeadings(source)
        const hasText = nodes => nodes.some(node => (node.text || '').trim() || hasText(node.children || []))
        const id = 'tone-panel-' + this._uid
        const heading = this.inAccordion && hasText(label) ? h('button', {
            class: 'tone-heading-button',
            attrs: { type: 'button', 'aria-expanded': this.open ? 'true' : 'false', 'aria-controls': this.open ? id : null }
        }, label) : label
        return h('div', { class: ['panel', this.panelType] }, [
            h('div', {
                class: ['panel-heading', { 'accordion-toggle': this.inAccordion }],
                on: {
                    click: event => {
                        event.preventDefault()
                        if (this.inAccordion) this.toggle()
                    }
                }
            }, [h('h4', { class: 'panel-title' }, [heading])]),
            h('transition', {
                props: { name: 'collapse' },
                on: { enter: this.enter, 'after-enter': this.afterEnter, 'before-leave': this.beforeLeave }
            }, [this.open ? h('div', { class: 'panel-collapse', attrs: { id } }, [
                h('div', { class: 'panel-body' }, this.$slots.default)
            ]) : null])
        ])
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Panel.js